module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 144
// module chunks = 0